import { DippiTree } from "@dippi/icons";
import { ListItem } from "@/components/brands";
import { withErrorBoundary } from "@/components/hoc";
import React from "react";
import { Styled } from "./styles";
import { Box } from "@mui/material";
import { isArrayWithData } from "@/utils/validations";
import useQueryBrands from "@/hooks/queries/useQueryBrands";

const Brands: React.FC = () => {
    const { data: brands } = useQueryBrands();

    if (!brands) return <Styled.Container />;

    return (
        <Styled.Container>
            {!isArrayWithData(brands) ? (
                <Box display="flex" flex={1} alignItems="center" justifyContent="center">
                    <DippiTree />
                </Box>
            ) : brands ? (
                <Styled.List>
                    {brands.map((i, index) => (
                        <ListItem key={i._id} {...i} index={index} />
                    ))}
                </Styled.List>
            ) : null}
        </Styled.Container>
    );
};

export default withErrorBoundary({ component: "Brands" })(Brands);
